/* Device-local favourites. Product availability and prices always come from Shopify. */
(() => {
  if (window.CPWishlist) return;
  const key = 'camporian-wishlist-v1';
  const limit = 100;
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
  let items = [], persistent = true;
  function parse(raw) {
    const value = JSON.parse(raw || 'null');
    if (!value || value.version !== 1 || !Array.isArray(value.items)) return [];
    const seen = new Set();
    return value.items.filter(item => {
      if (!validHandle(item?.handle) || seen.has(item.handle)) return false;
      seen.add(item.handle);return true;
    }).slice(0,limit).map(item=>({handle:item.handle,addedAt:Number(item.addedAt)||0}));
  }
  function read() {
    if (!persistent) return items;
    try { return parse(localStorage.getItem(key)); }
    catch { persistent = false;return items; }
  }
  items = read();
  function updateButtons(root = document) {
    const buttons = [...root.querySelectorAll('[data-cp-wishlist-save]')];
    if (root.matches?.('[data-cp-wishlist-save]')) buttons.unshift(root);
    buttons.forEach(button => {
      const handle = button.dataset.wishlistHandle;
      if (!validHandle(handle)) return;
      const saved = items.some(item=>item.handle === handle);
      const title = button.dataset.wishlistTitle || 'this piece';
      button.hidden = false;
      button.setAttribute('aria-pressed',String(saved));
      button.setAttribute('aria-label',saved?`Remove ${title} from your wishlist`:`Save ${title} to your wishlist`);
      button.title = saved?'Remove from wishlist':'Save to wishlist';
      const label = button.querySelector('[data-wishlist-label]');
      if (label) label.textContent = saved?'Saved to wishlist':'Save to wishlist';
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(counter=>{counter.textContent=String(items.length);counter.hidden=!items.length;});
    document.querySelectorAll('[data-wishlist-link]').forEach(link=>link.setAttribute('aria-label',items.length?`Wishlist, ${items.length} saved ${items.length===1?'piece':'pieces'}`:'Wishlist'));
    document.querySelectorAll('[data-wishlist-storage-note]').forEach(note=>{note.textContent=persistent?'Saved on this device.':'Saved for this visit. Your browser is not keeping this wishlist between visits.';});
  }
  function toggle(handle, title = 'Piece') {
    if (!validHandle(handle)) return;
    items = read();
    const saved = items.some(item=>item.handle === handle);
    if (!saved && items.length >= limit) {
      window.CPShopping?.announce('Your wishlist is full. Remove a piece to save another.',true);return;
    }
    items = saved ? items.filter(item=>item.handle!==handle) : [{handle,addedAt:Date.now()},...items];
    try { localStorage.setItem(key,JSON.stringify({version:1,items})); }
    catch { persistent = false; }
    updateButtons();
    document.dispatchEvent(new CustomEvent('cp:wishlist-change'));
    const message = saved ? 'Removed from your wishlist.' : persistent ? 'Saved to your wishlist.' : 'Saved for this visit. Your browser is not keeping the wishlist between visits.';
    window.CPShopping?.announce(message,!document.querySelector('cp-wishlist'));
  }
  window.CPWishlist = { toggle, has:handle=>items.some(item=>item.handle===handle), items:()=>items.map(item=>({...item})) };
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-cp-wishlist-save]');
    if (!button) return;
    event.preventDefault();toggle(button.dataset.wishlistHandle,button.dataset.wishlistTitle);
  });
  window.addEventListener('storage',event=>{
    if (event.key!==key && event.key!==null) return;
    try {items=parse(event.newValue);persistent=true;} catch {return;}
    updateButtons();document.dispatchEvent(new CustomEvent('cp:wishlist-change'));
  });
  window.addEventListener('pageshow',()=>{items=read();updateButtons();document.dispatchEvent(new CustomEvent('cp:wishlist-change'));});
  updateButtons();
  // Covers colour swaps, recommendation inserts and Load more without reloading the page.
  new MutationObserver(records=>{
    const roots=new Set();
    records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1 && (node.matches('[data-cp-wishlist-save]')||node.querySelector('[data-cp-wishlist-save]')))roots.add(node);}));
    roots.forEach(root=>updateButtons(root));
  }).observe(document.body,{childList:true,subtree:true});

  class Wishlist extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready=true;this.epoch=(this.epoch||0)+1;this.shown=12;this.controllers=new Set();this.inFlight=new Set();this.active=0;
      this.grid=this.querySelector('[data-wishlist-grid]');this.summary=this.querySelector('[data-wishlist-summary]');
      this.more=this.querySelector('[data-wishlist-more]');this.empty=this.querySelector('[data-wishlist-empty]');
      this.events=new AbortController();const options={signal:this.events.signal};
      this.grid.querySelectorAll('[data-state=loading]').forEach(row=>{row.dataset.state='pending';});
      this.refresh=()=>this.render();document.addEventListener('cp:wishlist-change',this.refresh,options);
      this.more.addEventListener('click',()=>{this.shown+=12;this.render();},options);
      this.addEventListener('click',event=>{
        const retry=event.target.closest('[data-wishlist-retry]');
        if (retry) {retry.closest('[data-wishlist-item]').dataset.state='pending';this.pump();}
      },options);
      this.render();
    }
    disconnectedCallback() {
      this.ready=false;this.epoch++;this.events?.abort();this.controllers?.forEach(controller=>controller.abort());
    }
    render() {
      if (!this.isConnected) return;
      const wanted=items.slice(0,this.shown), handles=new Set(wanted.map(item=>item.handle));
      const existing=new Map([...this.grid.children].map(row=>[row.dataset.wishlistItem,row]));
      let lostFocus=false;
      existing.forEach((row,handle)=>{if(!handles.has(handle)){if(row.contains(document.activeElement))lostFocus=true;row.remove();}});
      wanted.forEach((item,index)=>{
        let row=existing.get(item.handle);
        if (!row) {
          row=document.createElement('div');row.dataset.wishlistItem=item.handle;row.dataset.state='pending';
          const placeholder=document.createElement('div');placeholder.className='cp53-wishlist-placeholder';placeholder.textContent='Loading saved piece…';row.append(placeholder);
        }
        const current=this.grid.children[index];
        if(current!==row)this.grid.insertBefore(row,current||null);
      });
      this.empty.hidden=items.length>0;this.more.hidden=items.length<=this.shown;
      this.summary.textContent=items.length?`${items.length} saved ${items.length===1?'piece':'pieces'}${items.length>this.shown?` · showing ${this.shown}`:''}`:'';
      if (lostFocus) {
        const next=this.grid.querySelector('[data-cp-wishlist-save]')||this.closest('section').querySelector('.cp-editorial-link');
        next?.focus({preventScroll:true});
      }
      updateButtons(this);
      this.pump();
    }
    pump() {
      if (!this.isConnected) return;
      for (const row of this.grid.children) {
        if (this.active>=4) break;
        if (row.dataset.state!=='pending' || this.inFlight.has(row.dataset.wishlistItem)) continue;
        this.load(row);
      }
    }
    async load(row) {
      const handle=row.dataset.wishlistItem;const epoch=this.epoch;
      this.active++;this.inFlight.add(handle);row.dataset.state='loading';row.setAttribute('aria-busy','true');
      const controller=new AbortController();this.controllers.add(controller);
      const timeout=setTimeout(()=>controller.abort(),12000);
      try {
        const route=window.Shopify?.routes?.root||'/';
        const url=new URL(`${route}products/${encodeURIComponent(handle)}`,location.origin);
        url.searchParams.set('section_id','cp-collection-card');
        const theme=new URL(location.href).searchParams.get('preview_theme_id');if(theme)url.searchParams.set('preview_theme_id',theme);
        const response=await fetch(url.href,{credentials:'same-origin',signal:controller.signal});
        if (!response.ok) throw new Error('Unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const card=doc.querySelector('cp-collection-card');
        if (!card || card.dataset.productHandle!==handle || !card.querySelector('[data-card-gallery]')) throw new Error('Missing product');
        if (epoch!==this.epoch || !row.isConnected || !this.isConnected || !items.some(item=>item.handle===handle)) return;
        // A saved colour stays identifiable. Other swatches link to their own product page.
        card.querySelectorAll('[data-cp-card-colour]').forEach(swatch=>{swatch.removeAttribute('data-cp-card-colour');swatch.removeAttribute('role');swatch.removeAttribute('aria-pressed');});
        row.replaceChildren(card);row.dataset.state='ready';updateButtons(row);
      } catch {
        if (epoch!==this.epoch || !row.isConnected || !this.isConnected || !items.some(item=>item.handle===handle)) return;
        const panel=document.createElement('div');panel.className='cp53-wishlist-error';
        const message=document.createElement('p');message.textContent='We couldn’t load this saved piece. It may be unavailable, or your connection may have dropped.';
        const retry=document.createElement('button');retry.type='button';retry.dataset.wishlistRetry='';retry.textContent='Try again';
        const open=document.createElement('a');open.href=(window.Shopify?.routes?.root||'/')+'products/'+encodeURIComponent(handle);open.textContent='View product';
        const remove=document.createElement('button');remove.type='button';remove.dataset.cpWishlistSave='';remove.dataset.wishlistHandle=handle;remove.dataset.wishlistTitle='this piece';remove.textContent='Remove';
        panel.append(message,retry,open,remove);row.replaceChildren(panel);row.dataset.state='error';updateButtons(row);
      } finally {
        clearTimeout(timeout);if(epoch===this.epoch){this.controllers.delete(controller);this.active--;this.inFlight.delete(handle);row.removeAttribute('aria-busy');this.pump();}
      }
    }
  }
  if (!customElements.get('cp-wishlist')) customElements.define('cp-wishlist',Wishlist);
})();
